const config = {
    'env': 'production',
    'sentryDsn': 'https://18bc3a569f79426f9f963c9df9f27701@o429979.ingest.sentry.io/5385102',
    'sentrySampleRate': 0.1
}

export default config;